function Published2021() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-1/6 text-center">2021</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-full">
                        <p>M. Kim, <a href="https://www.worldscientific.com/doi/10.1142/S0129167X21500531" target="_blank" className="text-sky-600">“A pair of homotopy-theoretic version of TQFT’s induced by a Brown functor.”</a></p>
                        <p>International Journal of Mathematics 32.08 (2021): 2150053. (45 pages)</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-full">
                        <p>M. Kim, <a href="https://link.springer.com/article/10.1007/s00220-021-04080-4" target="_blank" className="text-sky-600">“Kitaev’s stabilizer code and chain complex theory of bicommutative Hopf algebras.”</a></p>
                        <p>Communications in Mathematical Physics 385.1 (2021): 291-329</p>
                    </div>
                </div>
                
                <div className="flex mt-2">
                    <div className="w-full">
                        <p>M. Kim, <a href="https://link.springer.com/article/10.1007/s10485-020-09627-5#citeas" target="_blank" className="text-sky-600">“Integrals along bimonoid homomorphisms.”</a></p>
                        <p>Applied Categorical Structures 29.4 (2021): 577-627</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Published2021;